import React from 'react';
import { renderToString } from 'react-dom/server';

import makeChartConfig from '../../../../../components/Chart/LineChart';
import { format } from '../../../../../utils/date';
import { numberToPercentage } from '../../../../../utils/formatter';
import { zooming } from '../../../configs/chart-config';

const tooltipPrecisionConfig = { precision: 1 };

export const getChartConfig = ({ hoveredItem, onClick, onMouseOver, onMouseOut }) =>
  makeChartConfig({
    chartOptions: {
      type: 'areaspline',
      spacing: [10, 0, 4, 0],
      height: 230,
      zooming,
    },
    yAxisOptions: {
      title: null,
      floor: 0,
      ceiling: 101,
      startOnTick: true,
      endOnTick: false,
      gridLineWidth: 1,
      gridLineColor: '#EDF0F5',
      labels: {
        reserveSpace: true,
        style: {
          color: '#848EA1',
          fontSize: 12,
        },
        formatter() {
          return `${this.value}%`;
        },
      },
    },
    xAxisOptions: {
      tickLength: 0,
      lineWidth: 1,
      lineColor: '#EDF0F5',
      crosshair: {
        color: '#E1E5EB',
        width: 1,
      },
      type: 'datetime',
      showFirstLabel: true,
    },
    xAxisLabels: {
      formatter() {
        if (this.isFirst || this.isLast) {
          return `<span class="text-nowrap">${format(this.value, 'MMM ‘YY')}</span>`;
        }
        return '';
      },
      style: {
        color: '#848EA1',
        fontSize: 12,
        textOverflow: 'none',
        width: 40,
      },
      useHTML: true,
    },
    legendOptions: {
      enabled: false,
    },
    tooltipOptions: {
      borderWidth: 0,
      padding: 0,
      shared: true,
      valueDecimals: 2,
      useHTML: true,
      outside: true,
      className: 'quick-view-tooltip',
      formatter() {
        if (!Array.isArray(this.points)) return false;

        const pointOptions = this.points[0].point.options;
        const isPartialElem = pointOptions.isPartial;

        const renderTooltipContent = (rowsContent) =>
          renderToString(
            <div
              style={{
                minWidth: '190px',
                borderRadius: '8px',
                border: '1px solid #E1E5EB',
                padding: '12px 16px',
                backgroundColor: '#fff',
                boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.08)',
              }}
            >
              <table className="table">
                <tr>
                  <td className="text-left text-black text-12 p-l-0 p-b-0 pr-md">
                    {format(this.x, 'MMM`YY')} {isPartialElem && '(Partial Period)'}
                  </td>
                </tr>
                {rowsContent}
              </table>
            </div>
          );

        return renderTooltipContent(
          this.points.map((point, index) => (
            <tr key={index}>
              <td className="text-left text-black text-14 p-l-0 p-b-0 pr-md">
                <div className="text-truncate text-black text-14" style={{ maxWidth: '100%' }}>
                  <span
                    className="tooltip-bubble-marker"
                    style={{
                      backgroundColor: point.color,
                      borderColor: point.color,
                    }}
                  />
                  <span>{point.series.name}</span>
                </div>
              </td>
              <td className="text-right text-black text-14 p-l-0 p-b-0">
                {point.isStub ? '—' : numberToPercentage(point.y, tooltipPrecisionConfig)}
              </td>
            </tr>
          ))
        );
      },
    },
    plotOptionsSettings: {
      series: {
        accessibility: { enabled: true },
        inactiveOtherPoints: false,
        zIndex: 10,
        stickyTracking: false,
        marker: {
          enabled: false,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        states: {
          hover: {
            enabled: true,
            linkOpacity: 0.6,
          },
          inactive: {
            enabled: true,
            opacity: 0.1,
            linkOpacity: 0.1,
          },
        },
      },
      areaspline: {
        stacking: 'normal',
        trackByArea: true,
        events: {
          mouseOver() {
            if (onMouseOver && hoveredItem?.id !== this.options.id) {
              onMouseOver({ id: this.options.id });
            }
          },
          mouseOut() {
            if (onMouseOut) {
              onMouseOut({ id: this.options.id });
            }
          },
          click() {
            if (onClick) onClick({ id: this.options.id });
          },
        },
      },
    },
  });
